import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  en: {
    translation: {},
  },
  es: {
    translation: {
      // General
      close: "Cerrar",
      save_changes: "Guardar cambios",
      save_all_changes: "Guardar todos los cambios",
      Actions: "Acciones",
      successfull_action: "Operación realizada",
      loading: "Cargando",
      delete: "Eliminar",
      back: "Volver",

      // Auths
      sign_up: "Identificarse",
      Unauthenticated: "Debes volver a hacer login, tu sesión ha expirado",
      email_or_user: "Correo o usuario",
      email_or_user_placeholder: "Ingrese su correo o usuario",
      password: "Contraseña",
      password_placeholder: "Ingrese su contraseña",
      sign_in: "Iniciar sesión",
      forgot_password: "¿Olvidaste tu contraseña?",
      logout: "Cerrar sesión",
      reset_password: "Recuperar contraseña",
      sent_reset_password:
        "Te hemos enviado un correo para poder recuperar tu contraseña",
      password_changing: "Introduce tu nueva contraseña",
      password_confirmed: "Confirmar contraseña",
      change_password: "Cambiar contraseña",
      send_reset_password: "Enviar correo de recuperación",
      invalid_credential: "Credenciales incorrectos",
      not_active_account: "Su cuenta está desactivda y no puede acceder",
      not_confirmed_account:
        "Su cuenta aún no ha sido confirmada. Por favor, revise su correo para activar su cuenta",
      confirmed_account: "Cuenta confirmada",
      account_confirmed_can_login: "Cuenta validada correctamente. Ya puedes hacer login.",
      commission_info_prefix: "Se aplica un",
      commission_info_suffix: "de comisión sobre el precio base.",
      invalid_token: "Token inválido",
      // Usuarios
      users: "Usuarios",
      name: "Nombre",
      surnames: "Apellidos",
      email: "Correo",
      password_confirmation: "Confirmación de contraseña",
      role: "Rol",
      create_user: "Crear usuario",
      edit_user: "Editar usuario",
      remove_user: "Eliminar usuario",
      "are_you_sure_you_want_to_remove_this_user?":
        "¿Estás seguro de que deseas eliminar este usuario?",

      // Actividad de usuarios
      users_activity: "Actividad de usuarios",

      // Sidebar
      configurations: "Configuraciones",
      profile: "Perfil",

      // Cms

      pages: "Páginas",
      page: "Página",
      blog: "Blog",
      create_page: "Crear entrada",
      article: "Entrada del blog",
      title: "Titulo",
      main_data: "Datos principales",
      header: "Cabecera",
      template: "Plantilla",
      logo: "Logo",
      entries: "Entradas menú",
      type: "Tipo",
      internal_page: "Página interna",
      external_page: "Página externa",
      hierarchy: "Jerarquía",
      parent_id: "Entrada padre",
      select_entry: "Selecciona una entrada",
      label: "Titulo",
      create_entry: "Crear entrada",
      edit_entry: "Editar entrada",
      page_id: "Página",
      "Max 3 items": "Máximo 3 productos",
      footer: "Pie de página",
      select_a_product: "Selecciona un producto",
      select_an_option: "Selecciona una opción",
      add_slide: "Añadir slide",
      add_product: "Añadir producto",
      feature: "Característica",
      add_feature: "Añadir característica",
      yes: "Si",
      no: "No",
      "Drag 'n' drop some files here, or click to select files":
        "Arrastra aquí tu archivo o haz clic para seleccionar uno",
      remove_image: "Eliminar imagen",
      remove_page: "Eliminar entrada",
      "are_you_shure_you_want_to_delete_this_page?":
        "¿Está seguro de que desea eliminar esta entrada?",
      // Clientes
      alternative_email: "Correo alternativo",
      phone: "Teléfono",
      street: "Dirección (línea 1)",
      address_2: "Dirección (línea 2)",
      city: "Población",
      postal_code: "Código postal",
      state: "Provincia",
      select_a_state: "Selecciona una provincia",
      observations: "Observaciones",
      discount: "Descuento",
      customer_create_address:
        "Crear una dirección de entrega con la dirección de los datos proporcionados",
      create_invoice_account:
        "Crear una dirección de facturación con la dirección de los datos proporcionados",
      export: "Exportar",
      shipping_address: "Dirección de entrega",
      billing_address: "Dirección de facturación",
      tags: "Categorías de blog",
      create_tag: "Crear categoría",
      edit_tag: "Editar categoría",
      remove_tag: "Eliminar categoría",
      "are_you_shure_you_want_to_delete_this_tag?":
        "¿Está seguro de que desea eliminar esta categoría?",
      remove_entry: "Eliminar entrada",
      "are_you_sure_you_want_to_delete_this_entry?":
        "¿Está seguro de que desea eliminar esta entrada?",

      // Direcciones
      create_address: "Crear dirección",
      edit_address: "Editar dirección",
      Addresses: "Direcciones",
      create: "Crear",
      country: "País",
      state_province: "Provincia",
      longitude: "Longitud",
      latitude: "Latitud",
      google_map_link: "Google map",
      address: "Dirección",

      // Facturacion
      invoice_account: "Datos de Facturación",
      fiscal_name: "Nombre / Razón social",
      fiscal_first_surname: "Apellidos",
      fiscal_address: "Dirección (línea 1)",
      fiscal_zip: "Código postal",
      fiscal_city: "Población",
      fiscal_province: "Provincia",
      fiscal_number: "CIF/DNI",
      fiscal_country_code: "País",

      // Minoristas
      retails: "Clientes",
      remove_retails: "Eliminar cliente",
      are_you_sure_you_want_to_delete_this_retails:
        "¿Está seguro de que desea eliminar este cliente?",
      create_retails: "Crear cliente",
      reset_password_email: "Reenviar email de activación de cuenta",
      are_you_sure_you_want_to_send_password_reset_email:
        "¿Está seguro de que desea reenviar el correo de activación de cuenta?",
      active_account: "Activar cuenta",
      are_you_sure_you_want_to_active_account:
        "¿Está seguro de que desea activar esta cuenta?",
      disable_account: "Desactivar cuenta",
      are_you_sure_you_want_to_disable_account:
        "¿Está seguro de que desea desactivar esta cuenta?",
      // Mayoristas
      dealers: "Distribuidores",
      dealer_name: "Nombre / Razón social",
      user_role_admin: "Admin",
      user_role_dealer: "Distribuidor",
      user_role_customer: "Cliente",
      user_role_producer: "Productor",
      create_dealers: "Crear distribuidor",
      remove_dealers: "Eliminar distribuidor",
      are_you_sure_you_want_to_delete_this_dealers:
        "¿Está seguro de que desea eliminar este distribuidor?",
      user_status_0: "Pendiente",
      user_status_1: "Activado",
      user_status_2: "Desactivado",

      // Productories
      producers: "Productores",
      producer_name: "Nombre / Razón social",
  producer_trade_name: "Nombre Comercial",
      create_producer: "Crear productor",
      remove_producer: "Eliminar productor",
      "are_you_sure_you_want_to_delete_this_producer?":
        "¿Está seguro de que desea eliminar este productor?",
      configuration_data: "Datos de configuración",

      // Categorías
      category: "Categoría",
      categories: "Categorías",
      create_category: "Crear categoría",
      edit_category: "Editar categoría",
      remove_category: "Eliminar categoría",
      select_a_category: "Selecciona categoría",
      "are_you_shure_you_want_to_delete_this_category?":
        "¿Está seguro de que desea eliminar esta categoría?",
      icon: "Clase para icono",
      select_icon: "Selecciona un icono",
      visible_in_combination: "Visible en variaciones",
      add_category: "Añadir categoría",

      // Productos
      Product: "Información básica",
      products: "Productos",
      create_product: "Crear producto",
      edit_product: "Editar producto",
      remove_product: "Eliminar producto",
      category_id: "Categoría",
      brand: "Marca",
      ref: "Referencia",
      description: "Descripción",
      attributes: "Etiquetas",
      published: "Publicado",
      published_1: "Si",
      published_0: "No",
      more_info: "Más información",
      producer: "Productor",
      producer_id: "Productor",
      select_producer: "Selecciona un productor",
      "pn-sierra-norte": "PN Sierra Norte",
      "pn-sierra-sur": "PN Sierra Sur",
      "pn-sierra-nevada": "PN Sierra Nevada",
      "pn-sierra-hornacuelos": "PN Sierra Hornacuelos",
      ahumados: "Ahumados",
      salazones: "Salazones",
      fermentados: "Fermentados",
      "marca-pna": "Marca pna",
      ecologico: "Ecológico",
      do: "DO",
      vegano: "Vegano",
      "sin-gluten": "Sin gluten",
      "sin-lactosa": "Sin lactosa",
      "sin-azucar": "Sin azucar",
      unidad: "Unidad",
      "cesta-regalo": "Cesta regalo",
      evento: "Evento",
      "are_you_sure_you_want_to_delete_this_product?":
        "¿Está seguro de que desea eliminar este producto?",
      add_document: "Añadir documento",
      document: "Documento",

      // Variantes
      combinations: "Formatos, stock y referencias",
      main_combination: "Referencia principal",
      combination_main_attribute: "Formato venta",
      create_combination: "Crear referencia",
      edit_combination: "Editar referencia",
      tax: "IVA",
      tax_percentage: "% IVA",
      commission: "Comisión",
      commission_percentage: "% Comisión",
      shipment_percentage: "% de envio",
      shipping: "Costes de envio",
      sku: "SKU",
      stock: "Stock",
      price: "Precio (IVA no Inc)",
      quantity: "Cantidad",
      unit_price: "Precio unitario",
      product: "Producto",
      subtotal: "Subtotal",
      commerce_price: "PVP (IVA Inc)",
      price_with_descount: "Precio final en oferta (IVA Inc)",
      gallery: "Galería",
      image_alt: "Alt imagen",
      remove_imagen: "Eliminar imagen",
      main: "Principal",
      img: "Imagen",
      other_combinations: "Otras referencias",
      remove_combination: "Eliminar referencia",
      "are_you_sure_you_want_to_delete_this_combination?":
        "¿Está seguro de que desea eliminar esta referencia?",
      role_segment_dealer: "Distribuidor",
      role_segment_customer: "Cliente",
      // Super orders
      super_orders: "Pedidos",
      super_order: "Pedido",
      status: "Estado",
      select_customer: "Cliente",
      pending: "Pendiente de pago",
      payed: "Pagado",
      managing_shipment: "Gestionando envio",
      delivered: "Entregado",
      in_transit: "En tránsito",
      completed: "Completado",
      cancelled: "Cancelado",
      customer: "Cliente",
      in_preparation: "En preparación",
      reference: "Referencia",
      lower_order_status: "subpedidos",
      created_at: "Fecha",
      total: "Total",
      super_order_status_1: "Pendiente de pago",
      super_order_status_2: "Pagado",
      super_order_status_3: "Completado",
      super_order_status_4: "Cancelado",
      edit_observations: "Editar observaciones",
      request_invoice: "Solicitar factura",
      upload_invoice: "Subir factura",
      download_invoice: "Descargar factura",
      file: "Archivo",
      cancel_super_order: "Cancelar pedido",
      "are_you_sure_you_want_to_cancel_this_super_order?":
        "¿Estás seguro de que deseas cancelar este pedido?",
      edit_billing_address: "Editar dirección de facturación",
      "billing-address": "Dirección de facturación",
      edit_shipping_address: "Editar dirección de entrega",
      "shipping-address": "Dirección de entrega",
      country_code: "País",
      role_segment: "Tipo de cliente",
      dealer: "Distribuidor",
      role_segment_all: "Todos",
      payment_method: "Método de pago",
      fake: "Falso",
      wannme: "Wannme Redsys",
      wannme_paypal: "Wannme Paypal",
      wannme_bizum: "Wannme Bizum",
      net_price: "Precio neto",

      // Orders
      orders: "Pedidos",
      invoice_orders: "Pedidos pte. factura",
      order: "Pedido",
      change_status: "Cambiar estado a:",
      change_status_order: "Cambiar estado pedido",
      change_status_order_3:
        "¿Está seguro de que desea cambiar el estado de este pedido?",
      change_status_order_4:
        "¿Está seguro de que desea empezar con el proceso de envio?",
      change_status_order_5:
        "Esta acción debería realizarse automáticamente tras el pago del pedido. Confirmar solo en caso de que haya habido un problema con la empresa de transporte.",
      change_status_order_6:
        "Esta acción debería realizarse automáticamente tras el pago del pedido. Confirmar solo en caso de que haya habido un problema con la empresa de transporte.",
      change_status_order_7:
        "Esta acción debería realizarse automáticamente tras el pago del pedido. Confirmar solo en caso de que haya habido un problema con la empresa de transporte.",
      order_status_1: "Pendiente de pago",
      order_status_2: "Pagado",
      order_status_3: "En preparación",
      order_status_4: "Gestionando envio",
      order_status_5: "En envio",
      order_status_6: "Entregado",
      order_status_7: "Cancelado",
      weight: "Peso (en kg)",
      length: "Largo (en cm)",
      width: "Ancho (en cm)",
      height: "Alto (en cm)",
      download_label: "Descargar etiqueta envio",
      tracking_url: "Seguimiento envio",

      // Sale formats
      sale_formats: "Formatos de venta",
      create_sale_format: "Crear formato de venta",
      edit_sale_format: "Editar formato de venta",
      remove_sale_format: "Eliminar formato de venta",
      "are_you_sure_you_want_to_delete_this_sale_format?":
        "¿Está seguro de que desea eliminar este formato de venta?",
      sale_format: "Formato de venta",

      // Options
      options: "Opciones de attributos",
      create_option: "Crear opción",
      langs: "Valor",
      attribute: "Atributo",
      "Select an attribute": "Selecciona un atributo",
      name_lang_code: "Código único",
      edit_option: "Editar opción",
      remove_option: "Eliminar opción",
      "are_you_sure_you_want_to_delete_this_option?":
        "¿Está seguro de que desea eliminar esta opción? Puede que haya productos que la usen.",

      // Coupons
      coupons: "Cupones",
      Coupons: "Cupones",
      create_coupon: "Crear cupón",
      edit_coupon: "Editar cupón",
      remove_coupon: "Eliminar cupón",
      "are_you_sure_you_want_to_remove_this_coupon?":
        "¿Está seguro de que desea eliminar este cupón?",
      code: "Código",
      status_id: "Estado",
      inactive: "Inactivo",
      active: "Activo",
      type_id: "Tipo",
      percentage: "Porcentaje",
      fixed: "Fijo",
      start_date: "Fecha inicio",
      end_date: "Fecha fin",
      initial_amount: "Importe",
      uses: "Usos",
      remaining_uses: "Usos restantes",

      // Configuraciones
      sales_commission: "Porcentaje comisión de ventas",
      tax_sales_commission: "Porcentaje IVA comisión de ventas",
      shipments: "Porcentaje de envio",
      tax_shipments: "Porcentaje IVA de envio",
      shipping_minimum: "Envío mínimo por proveedor (€, IVA incluido)",
      shipping_maximum: "Envío máximo por proveedor (€, IVA incluido)",
      shipping_minimum_help: "Importe mínimo total de gastos de envío (IVA incluido) aplicado a cada subpedido. Se garantiza este mínimo aunque la suma de líneas resulte inferior.",
      shipping_maximum_help: "Importe máximo total de gastos de envío (IVA incluido) por subpedido. Dejar en 0 para no aplicar tope superior.",
      order_data: "Pedidos",
      website_data: "Datos de la web",

      // Balances
      balances: "Liquidaciones",
      balance: "Liquidación",
      my_balances: "Mis liquidaciones",
      order_amount: "Precio venta",
      commission_amount: "Comisión Marketplace",
      generate_invoices: "Generar liquidaciones",
      generate_invoices_confirm:
        "¿Generar las facturas de liquidación de los balances pendientes? Se creará una factura por productor.",
      generate_invoices_done: "Liquidaciones generadas. Revisa el listado.",

      // Couponable
      couponables: "Aplicado a",
      select_producers: "Selecciona productores",
      coupon_type_0: "Porcentaje",
      coupon_type_1: "Fijo",
      coupon_status_active: "Activo",
      coupon_status_inactive: "Inactivo",
      select_product: "Selecciona un producto",

      shipping_addresses: "Direcciones de entrega",
    },
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "es", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
